<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="gift-box">
        <div
          v-for="(item, key) in giftData.list"
          :key="key"
          class="gift-item"
        >
          <div class="gift">
            <div class="top" :data-text="item.name">{{ item.name }}</div>
            <div class="image">
              <img :src="getGiftImg(item.icon)" />
            </div>
            <div class="name">{{ item.rewardName }}</div>
          </div>
          <div class="reward-btn reward-btn--finish" v-if="item.status"></div>
          <div class="reward-btn reward-btn--enable" @click="getReward(item)" v-else-if="item.finish"></div>
          <div class="reward-btn" v-else></div>
        </div>
      </div>
      <div class="bottom">
        <div class="text">
          <template v-if="stage == 0">您已邀请<span>{{ inviteCount[2] }}</span>人预约</template>
          <template v-if="stage == 1">您已邀请<span>{{ inviteCount[2] }}</span>人预约，已邀请<span>{{ inviteCount[3] }}</span>人下载</template>
        </div>
        <div class="btn-group">
          <div class="invite-btn" @click="invite"></div>
          <div class="gift-btn" @click="openBag" v-if="stage == 1"></div>
        </div>
        <div class="rule" @click="openRuleDialog">活动规则</div>
      </div>
      <div class="character"></div>
    </div>
    <invitation-dialog :visible.sync="invitationDialogVisible" />
    <prize-dialog :prizeList="giftLog" :visible.sync="prizeDialogVisible" @success="handlePrizeSuccess" />
  </div>
</template>

<script>
import InvitationDialog from './components/InvitationDialog.vue'
import PrizeDialog from '@/views/mobile/components/prizeDialog/Index.vue'

import invitationMixins from '@/mixins/home/invitationMixins.js'

export default {
  name: 'MobileHomeInvitation',
  mixins: [invitationMixins],
  components: {
    InvitationDialog,
    PrizeDialog,
  },
}
</script>

<style lang="scss" scoped>
.module {
  height: 156.933333vw;

  &__title {
    height: 23.466666vw;
    background-position: center -92.8vw;
  }

  &__content {
    padding: 0 3.066666vw;
    width: 100%;
  }
}

.gift-box {
  display: flex;
  justify-content: space-between;
  margin-top: 5.6vw;
}

.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;

  .gift {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 29.866666vw;
    height: 51.866666vw;
    background: url('~@/assets/img/mobile/gift_bg2.png') no-repeat;
    background-size: 100%;
  }

  .top {
    margin-top: 7.6vw;
    font-family: Noto Serif SC;
    font-weight: 700;
    font-size: 4.8vw;
    line-height: 4.8vw;
    color: transparent;
    letter-spacing: .133333vw;
    -webkit-text-stroke: .666666vw #f3e8d1;

    &::before {
      content: attr(data-text);
      position: absolute;
      background-image: linear-gradient(180deg, #a83e22, #d67147);
      background-clip: text;
      color: transparent;
      -webkit-text-stroke: 0;
    }
  }

  .image {
    display: flex;
    align-items: center;
    margin-top: 5.733333vw;
    width: 14vw;
    height: 14vw;

    img {
      width: 100%;
    }
  }

  .name {
    margin-top: 4.8vw;
    width: 100%;
    text-align: center;
    font-size: 2.666666vw;
    color: #613811;
    white-space: pre-wrap;
  }

  .reward-btn {
    margin-top: 5.866666vw;
    width: 25.066666vw;
    height: 7.066666vw;
    background: url('~@/assets/img/mobile/reward_btn2.png') no-repeat;
    background-size: 100% 14.133333vw;
    background-position: 0 -7.066666vw;

    &--finish {
      background: url('~@/assets/img/pc/invitation_btn.png') no-repeat;
      background-size: 100%;
    }

    &--enable {
      background-position: 0 0;
    }
  }
}

.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5.333333vw;

  .text {
    margin-bottom: 2.933333vw;
    color: #6a5b52;
    font-size: 3.466666vw;

    span {
      margin: 0 1.2vw;
      color: #b22e2e;
      font-size: 4.8vw;
      font-weight: bold;
    }
  }
  
  .rule {
    margin-top: 5.333333vw;
    font-size: 3.466666vw;
    color: #3479a5;
    
    &:after {
      content: '';
      display: block;
      width: 100%;
      height: .133333vw;
      background: #3479a5;
    }
  }
}

.btn-group {
  display: flex;

  .invite-btn {
    width: 40.8vw;
    height: 11.1vw;
    background: url('~@/assets/img/mobile/invite_btn.png') no-repeat;
    background-size: 40.8vw 11.1vw;
  }

  .gift-btn {
    margin-left: 5.333333vw;
    width: 40.8vw;
    height: 11.333333vw;
    background: url('~@/assets/img/mobile/gift_btn.png') no-repeat;
    background-size: 100%;
  }
}
</style>